(function (w, d, t) {
  w.TiktokAnalyticsObject = t;
  var ttq = (w[t] = w[t] || []);
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
    'holdConsent',
    'revokeConsent',
    'grantConsent',
  ];

  ttq.setAndDefer = function (obj, method) {
    obj[method] = function () {
      obj.push([method].concat(Array.prototype.slice.call(arguments)));
    };
  };

  for (var i = 0; i < ttq.methods.length; i++) {
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }

  ttq.instance = function (id) {
    var inst = ttq._i[id] || [];
    for (var i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(inst, ttq.methods[i]);
    }
    return inst;
  };

  ttq.load = function (id, options) {
    var script = document.createElement('script');
    var firstScript = document.getElementsByTagName('script')[0];
    var src = 'https://analytics.tiktok.com/i18n/pixel/events.js';

    ttq._i = ttq._i || {};
    ttq._i[id] = [];
    ttq._i[id]._u = src;

    ttq._t = ttq._t || {};
    ttq._t[id] = +new Date();

    ttq._o = ttq._o || {};
    ttq._o[id] = options || {};

    script.type = 'text/javascript';
    script.async = true;
    script.src = src + '?sdkid=' + id + '&lib=' + t;

    firstScript.parentNode.insertBefore(script, firstScript);
  };

  ttq.load('D0D19MJC77UCMMV6H7D0');
  ttq.page();
})(window, document, 'ttq');
